export default __webpack_public_path__ + "static/media/win-modal.c8bd34a9.jpg";